var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "infographic__graphic__icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1510_901)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "infographic__graphic__icon-house",
    d: "M164.488 83.7193L87.0209 1.66C84.7891 -0.553333 81.1925 -0.553333 78.9791 1.66L46.7936 35.7453V16.6369C46.7936 14.5711 45.1151 12.8927 43.0494 12.8927H23.7749C21.7091 12.8927 20.0307 14.5711 20.0307 16.6369V64.076L1.51248 83.7193C-0.497968 85.8404 -0.497968 89.1604 1.47559 91.3C2.56381 92.4436 4.0947 93.0891 5.69937 93.0522H20.0491V160.467C20.0491 163.528 22.5207 166 25.5825 166H140.418C143.479 166 145.951 163.528 145.951 160.467V93.0522H160.301C161.887 93.0891 163.418 92.4436 164.524 91.3C166.516 89.1604 166.498 85.8404 164.488 83.7193ZM84.0329 85.7298C99.0651 88.8284 106.683 94.9889 106.683 104.064C106.683 113.138 98.5303 120.405 87.7218 122.121V132.173H78.2598V122.121C67.4514 120.405 59.2989 112.972 59.2989 104.064H68.7609C68.7609 109.339 75.2718 113.802 82.9816 113.802C90.6914 113.802 97.2023 109.339 97.2023 104.064C97.2023 102.404 97.2023 97.3682 81.9487 94.2142C66.9165 91.1156 59.2989 84.9551 59.2989 75.8804C59.2989 66.8058 67.4514 59.5387 78.2598 57.8233V47.7158H87.7218V57.8233C98.5303 59.5387 106.683 66.9718 106.683 75.8804H97.2207C97.2207 70.6053 90.7098 66.1418 83 66.1418C75.2903 66.1418 68.7794 70.6053 68.7794 75.8804C68.7794 77.5404 68.7794 82.5758 84.0329 85.7298Z",
    fill: "#63ACE0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "infographic__graphic__icon-red",
    d: "M20.0491 147.924V160.467C20.0491 163.528 22.5207 166 25.5825 166H140.418C143.479 166 145.951 163.528 145.951 160.467V147.924H20.0491Z",
    fill: "#E35505"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1510_901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 166,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.abd9bc31e7286a02ecbe503b6df9ae96.svg";
export { ForwardRef as ReactComponent };